import React, { ReactElement, useMemo } from 'react';
import { TFunction } from 'i18next';
import { getField } from 'components/blocks/BasicDetailsInnerBlock';
import {
    FieldInterface,
    FieldSize,
} from 'components/interfaces/GeneralInterface';
import { useTranslation } from 'utils/localization';
import { toDate } from 'utils/helpers/datetime';
import stylesBasicDetails from 'components/blocks/BasicDetailsBlock.module.scss';
import { MembershipValidityIntervalInterface } from 'components/interfaces/MembershipPaymentInterface';
import CrossCircle from 'components/icon/icons/cross_circle.svg';
import Icon from 'components/icon/Icon';
import BasicDetailsBlock from 'components/blocks/BasicDetailsBlock';
import styles from './MembershipBlock.module.scss';

interface Props {
    validity: MembershipValidityIntervalInterface;
    discipline: string;
    dueDate: string;
    amount: number;
}

const getFieldWithLocalization = (
    t: TFunction,
    validity: MembershipValidityIntervalInterface,
    dueDate: string,
    amount: number
): FieldInterface[] => {
    const res: FieldInterface[] = [];
    if (validity && validity.from)
        // eslint-disable-next-line prettier/prettier
        res.push(
            getField(
                t,
                toDate(validity.from),
                'Decision.from',
                FieldSize.P25,
                'M'
            )
        );
    if (validity && validity.to)
        // eslint-disable-next-line prettier/prettier
        res.push(
            getField(t, toDate(validity.to), 'Decision.to', FieldSize.P25, 'M')
        );
    if (amount)
        // eslint-disable-next-line prettier/prettier
        res.push(
            getField(t, amount + ' Kč', 'general.amount', FieldSize.P25, 'M')
        );
    if (dueDate)
        // eslint-disable-next-line prettier/prettier
        res.push(
            getField(
                t,
                toDate(dueDate),
                'Dashboard.dueDate',
                FieldSize.P25,
                'M'
            )
        );
    return res;
};

const MembershipPaymentInfoBlock = ({
    dueDate,
    validity,
    discipline,
    amount,
}: Props): ReactElement => {
    const { t } = useTranslation();

    const fields = useMemo<FieldInterface[]>(
        (): FieldInterface[] =>
            getFieldWithLocalization(t, validity, dueDate, amount),
        []
    );

    return (
        <BasicDetailsBlock
            fieldsWithLocalization={fields}
            className={stylesBasicDetails.sizeP40}
            childrenFirst
            isLight
        >
            <div className={styles.innerTitle}>
                <Icon icon={CrossCircle} className={styles.icon} noStrip />
                <div>{t('MemberProfile.membership-' + discipline)}</div>
            </div>
        </BasicDetailsBlock>
    );
};

export default MembershipPaymentInfoBlock;
